<template>
    <router-view>
        
    </router-view>
</template>

<script>

export default{
    layout:'guardian'
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/guardian/index.vue